'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onHasCompletion;

var _graphql = require('graphql');

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Render a custom UI for CodeMirror's hint which includes additional info
 * about the type and description for the selected context.
 */
/**
 *  Copyright (c) 2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

function onHasCompletion(cm, data, onHintInformationRender) {
  var CodeMirror = require('codemirror');

  var wrapper = void 0;
  var information = void 0;

  // When a hint result is selected, we touch the UI.
  CodeMirror.on(data, 'select', function (ctx, el) {
    // Only the first time (usually when the hint UI is first displayed)
    // do we create the wrapping node.
    if (!wrapper) {
      (function () {
        // Wrap the existing hint UI, so we have a place to put information.
        var hintsUl = el.parentNode;
        var container = hintsUl.parentNode;
        wrapper = document.createElement('div');
        container.appendChild(wrapper);

        // CodeMirror vertically inverts the hint UI if there is not enough
        // space below the cursor. Since this modified UI appends to the bottom
        // of CodeMirror's existing UI, it could cover the cursor. This adjusts
        // the positioning of the hint UI to accomodate.
        var top = hintsUl.style.top;
        var bottom = '';
        var cursorTop = cm.cursorCoords().top;
        if (parseInt(top, 10) < cursorTop) {
          top = '';
          bottom = window.innerHeight - cursorTop + 3 + 'px';
        }

        // Style the wrapper, remove positioning from hints. Note that usage
        // of this option will need to specify CSS to remove some styles from
        // the existing hint UI.
        wrapper.className = 'CodeMirror-hints-wrapper';
        wrapper.style.left = hintsUl.style.left;
        wrapper.style.top = top;
        wrapper.style.bottom = bottom;
        hintsUl.style.left = '';
        hintsUl.style.top = '';

        // This "information" node will contain the additional info about the
        // highlighted typeahead option.
        information = document.createElement('div');
        information.className = 'CodeMirror-hint-information';
        if (bottom) {
          wrapper.appendChild(information);
          wrapper.appendChild(hintsUl);
        } else {
          wrapper.appendChild(hintsUl);
          wrapper.appendChild(information);
        }

        // When CodeMirror attempts to remove the hint UI, we detect that it was
        // removed from our wrapper and in turn remove the wrapper from the
        // original container.
        var _onRemoveFn = void 0;
        wrapper.addEventListener('DOMNodeRemoved', _onRemoveFn = function onRemoveFn(event) {
          if (event.target === hintsUl) {
            wrapper.removeEventListener('DOMNodeRemoved', _onRemoveFn);
            wrapper.parentNode.removeChild(wrapper);
            wrapper = null;
            information = null;
            _onRemoveFn = null;
          }
        });
      })();
    }

    // Now that the UI has been set up, add info to information.
    var description = ctx.description ? (0, _marked2.default)(ctx.description, { smartypants: true }) : 'Self descriptive.';
    var type = ctx.type ? '<span class="infoType">' + renderType(ctx.type) + '</span>' : '';

    information.innerHTML = '<div class="content">' + (description.slice(0, 3) === '<p>' ? '<p>' + type + description.slice(3) : type + description) + '</div>';

    // Additional rendering?
    if (onHintInformationRender) {
      onHintInformationRender(information);
    }
  });
}

function renderType(type) {
  if (type instanceof _graphql.GraphQLNonNull) {
    return renderType(type.ofType) + '!';
  }
  if (type instanceof _graphql.GraphQLList) {
    return '[' + renderType(type.ofType) + ']';
  }
  return '<a class="typeName">' + type.name + '</a>';
}


//////////////////
// WEBPACK FOOTER
// ./~/graphiql/dist/utility/onHasCompletion.js
// module id = ./node_modules/graphiql/dist/utility/onHasCompletion.js
// module chunks = 0